import { IntlShape } from 'react-intl';

import { eventTracking } from '@/services/event-tracking';
import { CountryCode } from '@/shared/models/country-code';

import { ICard, ICardContext } from '../types';

import { assignTipTextForCardItems } from './assignTipTextForCardItems';
import { getItem } from './getItem';

const createDriversCards = (
  context: ICardContext,
  onNavigate: (uri: string) => void,
  intl: IntlShape,
  user: { isFleet: boolean; isIndividualChauffeurRU: boolean; isFleetAndChauffeur: boolean },
): ICard[] => {
  const { items, cardStatus } = getItem({
    entities: context.drivers ? context.drivers : [],
    docDefinitions: context.driverUploadDefinitions,
    getTitle: driver => `${driver.firstName} ${driver.lastName}`,
    getItemAction: driver => () => {
      eventTracking.trackSnowplow({
        event: 'Onboarding - Documents - Open',
        type: 'chauffeur',
      });

      if (user.isFleet || user.isIndividualChauffeurRU || user.isFleetAndChauffeur) {
        onNavigate(`/chauffeurs/${driver.id}#docs`);
      } else {
        onNavigate(`/profile#docs`);
      }
    },
  });

  const itemsWithTips = assignTipTextForCardItems(intl, items);

  return [
    {
      id: 'driver',
      isBlocked: false,

      action: () => {
        onNavigate(`/add-chauffeur`);
      },

      actionTitle:
        user.isFleet || user.isIndividualChauffeurRU || user.isFleetAndChauffeur
          ? intl.formatMessage({
              defaultMessage: 'Add chauffeur',
              id: 'HCoCiN',
              description: 'todo list card text',
            })
          : undefined,

      title: (() => {
        if (cardStatus === 'done') {
          return intl.formatMessage({
            defaultMessage: 'Chauffeur documents approved',
            id: 'MO7l4F',
            description: 'ToDo driver card: title',
          });
        }

        if (cardStatus === 'review') {
          return intl.formatMessage({
            defaultMessage: 'Chauffeur documents',
            id: 'FexXr1',
            description: 'ToDo partner card: title',
          });
        }

        return intl.formatMessage({
          defaultMessage: 'Add chauffeur documents',
          id: 'xbgMpw',
          description: 'todo list card text',
        });
      })(),

      desc: (() => {
        switch (context.partner.countryCode) {
          case CountryCode.GreatBritain:
            return intl.formatMessage({
              defaultMessage:
                'DVLA Plastic Driving Licence and Private Hire Driver Licence (PCO) are required.',
              id: 'Dcf6yY',
              description: 'todo list card text: specific for GB',
            });
          case CountryCode.Russia:
            return intl.formatMessage({
              defaultMessage: 'Driving licence, passport and criminal record certificate.',
              id: 'todo_driver_card_documents_ru',
              description: 'todo list card text: specific for RU',
            });
          default:
            return '';
        }
      })(),
      items: itemsWithTips,
      cardStatus,
    },
  ];
};

export { createDriversCards };
